import * as React from 'react';
import { isNil } from 'lodash';

import ChannelTopUsed from './channels/ChannelTopUsed';

import type { Channel, MetricValueObject } from 'types';

type Props = {
  selectedChannel: Channel | undefined | null
};

class InfluencerChannelOverview extends React.PureComponent<Props> {
  getMetricValue(key: string): Array<MetricValueObject> {
    const { selectedChannel } = this.props;

    return selectedChannel?.metrics && selectedChannel?.metrics[key] ? this.getMetrics(selectedChannel.metrics[key]) : [];
  }

  getMetrics(metricValue: Array<{ name: string, amount: number }> | null): Array<MetricValueObject> {
    return (metricValue ?? []).map(entry => ({ name: entry.name, count: entry.amount }));
  }

  renderSection(): React.ReactNode {
    const { selectedChannel } = this.props;
    const mixedType = selectedChannel && selectedChannel.type === 'youtube' ? 'tag' : 'hashtag';

    return (
      <div className="influencer-channel-overview__section">
        <ChannelTopUsed
          type={mixedType}
          width="wide"
          maxElements={100}
          metrics={this.getMetricValue('topHashtags')}
        />
        <ChannelTopUsed
          type="brand"
          width="wide"
          maxElements={100}
          metrics={this.getMetricValue('topBrands')}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    const { selectedChannel } = this.props;

    if (isNil(selectedChannel)) {
      return null;
    }

    return (
      <div
        className="influencer-channel-overview"
        data-qa="influencer-channel-overview"
      >
        {this.renderSection()}
      </div>
    );
  }
}

export default InfluencerChannelOverview;
